import { render, staticRenderFns } from "./ordersalelist.vue?vue&type=template&id=f075b7e8&scoped=true"
import script from "./ordersalelist.vue?vue&type=script&lang=js"
export * from "./ordersalelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f075b7e8",
  null
  
)

export default component.exports